import BsjSetDriverVehicleinfoRegistrationnumModal from './bsj-set-driver-vehicleinfo-registrationnum-modal.vue'
export default BsjSetDriverVehicleinfoRegistrationnumModal
